angular.module('iw.frontyard.equal_repayment_calculator')
    .directive('iwEqualRepaymentCalculator', function (FRONTYARD_ROOT_URL,
                                                       calculateTablePadding,
                                                       EqualRepaymentScheduler,
                                                       $window,
                                                       IwocaUrlHelper) {
        return {
            restrict: 'E',
            scope: {
                amountSlider: '=',
                durationSlider: '=',
                rateSlider: '=',
                minimumAmount: '=',
                maximumAmount: '=',
                initialAmount: '=',
                minimumDuration: '=',
                maximumDuration: '=',
                initialDuration: '=',
                minimumRate: '=',
                maximumRate: '=',
                initialRate: '=',
                currencySymbol: '@',
            },
            transclude: true,
            templateUrl: FRONTYARD_ROOT_URL + 'frontyard/equal_repayment_calculator/directives/iwEqualRepaymentCalculator.html',
            compile: function () {
                return {
                    pre: function ($scope, ngModel) {
                        const DEFAULT_VALUES = {
                            durationFromUrl: parseInt(IwocaUrlHelper.deserializeParams($window.location.search, 'duration')),
                            amountFromUrl: parseInt(IwocaUrlHelper.deserializeParams($window.location.search, 'amount')),
                        };
                        var loan = {
                            amount: DEFAULT_VALUES.amountFromUrl || $scope.initialAmount,
                            duration: DEFAULT_VALUES.durationFromUrl || $scope.initialDuration,
                            rate: $scope.initialRate,
                            annualPercentageRate: $window.ANNUAL_PERCENTAGE_RATE,
                        };
                        $scope.loan = loan;
                        let increment = 500;
                        var scheduler = new EqualRepaymentScheduler($window.SITE_CODE, $window.REPRESENTATIVE_SIMPLE_RATES, $window.DEFAULT_FEE_RATE);
                        scheduler.calculateSchedule(loan.amount, loan.duration, loan.rate);
                        $scope.scheduler = scheduler;
                        $scope.currencyDigits = scheduler.currencyDigits;
                        $scope.amountConfig = {
                            min: $scope.minimumAmount,
                            max: $scope.maximumAmount,
                            value: $scope.loan.amount,
                            step: 500,
                            range: 'min',
                            slide: function (event, ui) {
                                var amount = ui.value;
                                scheduler.calculateSchedule(amount, loan.duration, loan.rate);
                                $scope.$applyAsync();
                            },
                            change: function (event, ui) {
                                var amount = ui.value;
                                scheduler.calculateSchedule(amount, loan.duration, loan.rate);
                                $scope.isAmountSliderActive();
                                $scope.$applyAsync();
                            },
                            start: function() {
                                $scope.changeAmountColourOnSlide = true;
                            },
                            stop: function() {
                                $scope.changeAmountColourOnSlide = false;
                            }
                        };
                        $scope.durationConfig = {
                            min: $scope.minimumDuration,
                            max: $scope.maximumDuration,
                            value: $scope.loan.duration,
                            range: 'min',
                            slide: function (event, ui) {
                                scheduler.calculateSchedule($scope.scheduler.totalAmount, ui.value, loan.rate);
                                $scope.smallPadding = calculateTablePadding(ui.value);
                                $scope.$applyAsync();
                            },
                            change: function (event, ui) {
                                scheduler.calculateSchedule($scope.scheduler.totalAmount, ui.value, loan.rate);
                                $scope.smallPadding = calculateTablePadding(ui.value);
                                $scope.isAmountSliderActive();
                                $scope.$applyAsync();
                            },
                            start: function() {
                                $scope.changeDurationColourOnSlide = true;
                            },
                            stop: function() {
                                $scope.changeDurationColourOnSlide = false;
                            }
                        };

                        if ($scope.rateSlider) {
                            $scope.rateConfig = {
                                min: $scope.minimumRate,
                                max: $scope.maximumRate,
                                value: $scope.initialRate,
                                range: 'min',
                                step: 0.01,
                                slide: function (event, ui) {
                                    scheduler.calculateSchedule($scope.scheduler.totalAmount, loan.duration, ui.value);
                                    $scope.smallPadding = calculateTablePadding(ui.value);
                                    $scope.$applyAsync();
                                },
                                change: function (event, ui) {
                                    scheduler.calculateSchedule($scope.scheduler.totalAmount, loan.duration, ui.value);
                                    $scope.smallPadding = calculateTablePadding(ui.value);
                                    $scope.isAmountSliderActive();
                                    $scope.$applyAsync();
                                }
                            };
                        }
                        $scope.isAmountSliderActive = function() {
                            var params = {
                                amount: $scope.loan.amount,
                                duration: $scope.loan.duration,
                            }
                            var serializedParams = IwocaUrlHelper.serializeParams(params);
                            IwocaUrlHelper.pushParamsToUrl(serializedParams);
                        };
                    },
                    post: function () {
                    }
                };
            }
        };
    });